import { render, staticRenderFns } from "./ReportPhotoEnterpriseOccurrence.vue?vue&type=template&id=00896cb7&"
import script from "./ReportPhotoEnterpriseOccurrence.vue?vue&type=script&lang=js&"
export * from "./ReportPhotoEnterpriseOccurrence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports